module.exports = __webpack_public_path__ + "static/img/278_TO8_2416.6a6299b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/278_TO8_2416.jpg
// module id = zYjT
// module chunks = 0